// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"9c2245ef","487":"3e197f14","934":"ccad50b0"}[chunkId] + ".chunk.js";
};